import React from 'react';

export default function SocialMedia() {
    const items =[
    {imageUrl:require("../../assets/Images/socialmedia/1.jpeg"),text:"Below ₹99",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/2.jpeg"),text:"Below ₹199",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/3.jpeg"),text:"Below ₹299",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/4.jpeg"),text:"Below ₹399",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/5.jpeg"),text:"Below ₹499",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/6.jpeg"),text:"Below ₹599",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/7.jpeg"),text:"Below ₹699",buttonLink:"#"},
    {imageUrl:require("../../assets/Images/socialmedia/8.jpeg"),text:"Below ₹799",buttonLink:"#"},
  ]
    return(
        <>
            <div className='col-12 col-lg-12 col-md-12 col-sm-12 mt-5'>
                <div className="heading3 text-center">Aelitez in social media</div>
            </div>
            <div className='col-12 col-lg-12 col-md-12 col-sm-12 pt-4'>
                <div className="heading3 text-center">
                    <a href="/" style={{alignContent:"center"}}>
                        <img src={require("../../assets/Images/AeliteZLogoWriteRed.gif")} alt="logo" style={{width:"40px",height:"30px",margin:"auto"}} />
                    </a>
                </div>
            </div>
            <div className='loop-container mt-4 mb-5'>
                
                    <div className="loop-track">
                        {[...items,...items].map((item, index) => (
                            <a href={'https://www.instagram.com/'} target='_blank' className="socialmedia-tile" key={index}>
                                <img src={item.imageUrl} alt='1'/>
                                <div className="button">
                                    <i className="bi bi-instagram" style={{color: '#fa7e1e'}}></i>
                                </div>
                            </a>
                        ))}
                    </div>
                
            </div>
        </>   
    )
}